import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { BrowserRouter as Router } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import ReactGA from 'react-ga';
import 'semantic-ui-css/semantic.min.css';
import 'bootstrap';
import { combinedStore } from './store/reducers/';
import { setupInterceptors } from './api';
import './index.css';
import { App } from './containers/App';
import registerServiceWorker from './registerServiceWorker';
import { ScrollToTop } from './components';

const { REACT_APP_GA_ID } = process.env;
ReactGA.initialize(REACT_APP_GA_ID, { debug: false });

const store = createStore(
  combinedStore,
  composeWithDevTools(applyMiddleware(thunkMiddleware)),
);

setupInterceptors(store);

ReactDOM.render(
  <Router>
    <ScrollToTop>
      <Provider store={store}>
        <App />
      </Provider>
    </ScrollToTop>
  </Router>,
  document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js